export default {
    setZCierres(state, a) {
        state.zcierres = a;
    },
    setZCierresAbiertos(state, a) {
        state.zcierresAbiertos = a;
    },
}